import React, { useState, useEffect } from 'react';
import { Cookie, X, Check } from 'lucide-react';

const COOKIE_KEY = 'peschiera_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => { localStorage.setItem(COOKIE_KEY, 'accepted'); setVisible(false); };
  const decline = () => { localStorage.setItem(COOKIE_KEY, 'declined'); setVisible(false); };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      style={{ background: 'rgba(10,10,15,0.97)', borderTop: '1px solid rgba(201,168,76,0.3)', backdropFilter: 'blur(20px)' }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-5">
        <div className="flex items-start gap-4 flex-1">
          <Cookie size={28} className="text-gold shrink-0 mt-0.5" />
          <div>
            <p className="text-white font-manrope font-700 text-base mb-1">Questo sito utilizza i cookie</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Utilizziamo cookie tecnici essenziali per il funzionamento del sito. Nessun cookie di profilazione.{' '}
              <a href="/cookie-policy" className="text-gold underline hover:text-gold-hover">
                Leggi la Cookie Policy
              </a>
            </p>
          </div>
        </div>
        <div className="flex gap-3 shrink-0 w-full md:w-auto">
          <button
            data-testid="cookie-decline"
            onClick={decline}
            className="btn-secondary flex-1 md:flex-none px-6 py-3 text-base"
            style={{ minHeight: '48px' }}
          >
            Solo essenziali
          </button>
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="btn-primary flex-1 md:flex-none px-6 py-3 text-base flex items-center gap-2"
            style={{ minHeight: '48px' }}
          >
            <Check size={18} /> Accetta
          </button>
        </div>
      </div>
    </div>
  );
}

export function CookiePolicyPage() {
  return (
    <div className="min-h-screen py-24 px-4" style={{ background: 'var(--bg-primary)' }}>
      <div className="max-w-3xl mx-auto">
        <a href="/" className="text-gold font-manrope text-sm hover:underline mb-8 inline-block">← Torna al sito</a>
        <h1 className="font-playfair text-4xl font-bold text-white mb-8">Cookie Policy</h1>
        <div className="space-y-8 text-gray-300 text-lg leading-relaxed font-manrope">
          <section>
            <h2 className="font-playfair text-2xl font-bold text-white mb-3">Cosa sono i cookie</h2>
            <p>I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo quando li visiti. Vengono usati per far funzionare il sito correttamente e per ricordare le tue preferenze.</p>
          </section>
          <section>
            <h2 className="font-playfair text-2xl font-bold text-white mb-3">Cookie utilizzati da questo sito</h2>
            <p className="mb-3">Questo sito utilizza esclusivamente <strong className="text-gold">cookie tecnici essenziali</strong>:</p>
            <div className="card-dark p-5 space-y-3">
              {[
                ['peschiera_cookie_consent', 'Salva le tue preferenze cookie', 'Sessione / 1 anno'],
                ['admin_token', 'Token di autenticazione pannello admin', 'Sessione'],
              ].map(([name, desc, duration]) => (
                <div key={name} className="flex flex-col sm:flex-row sm:items-center gap-1 border-b border-white/5 pb-3">
                  <span className="text-gold font-mono text-sm font-600 sm:w-56 shrink-0">{name}</span>
                  <span className="text-gray-300 text-sm flex-1">{desc}</span>
                  <span className="text-gray-500 text-xs shrink-0">{duration}</span>
                </div>
              ))}
            </div>
          </section>
          <section>
            <h2 className="font-playfair text-2xl font-bold text-white mb-3">Cookie di terze parti</h2>
            <p>Questo sito <strong className="text-white">non utilizza</strong> cookie di profilazione, cookie analitici di terze parti o cookie pubblicitari. La mappa incorporata nel footer utilizza OpenStreetMap, che potrebbe impostare i propri cookie tecnici.</p>
          </section>
          <section>
            <h2 className="font-playfair text-2xl font-bold text-white mb-3">Come disabilitare i cookie</h2>
            <p>Puoi disabilitare i cookie dal tuo browser. Tieni presente che disabilitando i cookie tecnici alcune funzionalità del sito potrebbero non funzionare correttamente.</p>
          </section>
          <section>
            <h2 className="font-playfair text-2xl font-bold text-white mb-3">Contatti</h2>
            <p>Per qualsiasi informazione: <a href="mailto:dancinglapeschiera@gmail.com" className="text-gold underline">dancinglapeschiera@gmail.com</a></p>
          </section>
          <p className="text-gray-500 text-sm">Ultimo aggiornamento: Febbraio 2026</p>
        </div>
      </div>
    </div>
  );
}
